import { ContentType, GridData } from '@bm-js/atlascloud-shared'
import { useMemo } from 'react'
import DynamicContentWrapper from './Editor/DynamicContentWrapper'
import DynamicContentSwitcher from './Editor/DynamicContentSwitcher'
import Draggable from './Draggable'
import EditorDroppable from './EditorDroppable'

type Props = {
  section: ContentType<unknown>[]
  sectionIndex: number
  gridContent: ContentType<GridData>
}

const GridContentSection = ({ section, sectionIndex, gridContent }: Props) => {
  const spanClass = useMemo(() => {
    if (
      gridContent.data.gridLayout === '1fr' ||
      !gridContent.data.mobileDirection ||
      gridContent.data.mobileDirection === 'normal'
    ) {
      return ''
    }

    if (gridContent.data.mobileDirection === 'reverse') {
      return sectionIndex === 0 ? '' : '@2xl/grid:row-start-[unset] row-start-1'
    }
    return ''
  }, [gridContent.data, sectionIndex])

  const shouldShowExtraDroppable = useMemo(() => {
    if (gridContent.data.gridLayout === '1fr') return sectionIndex === 0
    return true
  }, [gridContent, sectionIndex])

  return (
    <div
      className={`${spanClass}`}
      key={`gridInner_${gridContent.uuid}__${sectionIndex}`}
    >
      {section.map((content, contentIndex) => (
        <Draggable
          key={content.uuid}
          id={content.uuid}
          data={{
            content,
            source: {
              gridContent,
              sectionIndex,
              contentIndex,
            },
          }}
        >
          <EditorDroppable
            gridContent={gridContent}
            sectionIndex={sectionIndex}
            contentIndex={contentIndex}
          />
          <DynamicContentWrapper content={content}>
            <DynamicContentSwitcher key={content.uuid} content={content} />
          </DynamicContentWrapper>
        </Draggable>
      ))}

      {shouldShowExtraDroppable && (
        <EditorDroppable
          gridContent={gridContent}
          sectionIndex={sectionIndex}
          contentIndex={section.length}
        />
      )}
    </div>
  )
}

export default GridContentSection
